import AccessTimeIcon from '@mui/icons-material/AccessTime';
import GroupIcon from '@mui/icons-material/Group';
import LockIcon from '@mui/icons-material/Lock';
import LockOpen from "@mui/icons-material/LockOpen";
import LoginIcon from '@mui/icons-material/Login';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import CheckIcon from '@mui/icons-material/Check'
import {
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
  Stack,
  Box,
} from '@mui/material';
import {Fragment, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {secured as axios} from '../../axios';
import {useDarkMode} from '../darkMode/hook/useDarkMode';
import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import {imageExists} from "../helper/image";

const CommunityCard = ({community, sx, member}) => {
  const [isFavorite, setIsFavorite] = useState(community.favorite);
  const navigate = useNavigate();
  const [joinButtonDisabled, setJoinButtonDisabled] = useState(
    community.pending_join,
  );
  const [textAfterJoin, setTextAfterJoin] = useState(
    community.public_access.bool ? 'Publique' : 'Private',
  );
  const {mode} = useDarkMode();
  const [isLoadingJoin, setIsLoadingJoin] = useState(false);

  React.useEffect(() => {
    setJoinButtonDisabled(community.pending_join);
  }, [community.pending_join]);

  const addToFavorite = () => {
    axios
      .post(`${axios.defaults.apiURL}/${community.identifier}/${community.id}/favorite`, {
        communityId: community.id,
      })
      .then(function (response) {
        if (response.status === 201) {
          setIsFavorite(true);
        }
      })
      .catch(function (error) {
        if (error.response) {
          if (error.response.status === 401) {
            localStorage.clear();
            navigate('/login');
          }
        }
      });
  };

  const removeFromFavorite = () => {
    axios
      .delete(`${axios.defaults.apiURL}/${community.identifier}/${community.id}/favorite`, {
        communityId: community.id,
      })
      .then(function (response) {
        if (response.status === 204) {
          setIsFavorite(false);
        }
      })
      .catch(function (error) {
        if (error.response) {
          if (error.response.status === 401) {
            localStorage.clear();
            navigate('/login');
          }
        }
      });
  };
  const join = (id, publicAccess) => {
    setIsLoadingJoin(true);
    if (publicAccess) {
      axios
        .post(`${axios.defaults.apiURL}/community-public/join`, {
          contentId: id,
        })
        .then(function (response) {
          setIsLoadingJoin(false);
          if (response.status === 200) {
            setJoinButtonDisabled(true);
            setTextAfterJoin('Public');
          }
        })
        .catch(function (error) {
          setIsLoadingJoin(false);
          if (error.response) {
            if (error.response.status === 401) {
              localStorage.clear();
              navigate('/login');
            }
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          }
        });
    } else {
      axios
        .post(`${axios.defaults.apiURL}/community-private/join`, {
          contentId: id,
        })
        .then(function (response) {
          setIsLoadingJoin(false);
          if (response.status === 200) {
            setJoinButtonDisabled(true);
            setTextAfterJoin('Private');
          }
        })
        .catch(function (error) {
          setIsLoadingJoin(false);
          if (error.response) {
            if (error.response.status === 401) {
              localStorage.clear();
              navigate('/login');
            }
          }
        });
    }
  };

  return (
    <Card sx={sx} variant="outlined">
      <CardContent
        sx={{
          backgroundColor: `${mode.settings.cardBackgroundColor} !important`,
          paddingBottom: '16px !important'
        }}>
        <Stack spacing={'10px'}>
          <div
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'space-between',
            }}>
            <div style={{marginRight: 2, marginBottom: '8px'}}>
              <div style={{display: 'flex', alignItems: 'center'}}>
                {community.public_access.bool ?
                    <LockOpen
                        role="img"
                        aria-label={"Type d'accés à la communauté"}
                        style={{color: mode.settings.textColor3}}
                    />:
                    <LockIcon
                        role="img"
                        aria-label={"Type d'accés à la communauté"}
                        style={{color: mode.settings.textColor3}}
                    />
                }

                <Typography
                  variant="subtitle5"
                  style={{color: mode.settings.textColor3, paddingTop: '5px'}}>
                  {community.public_access.bool ? 'Publique' : 'Privée'}
                </Typography>
              </div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                }}>
                <GroupIcon
                  role={'img'}
                  aria-label="Nombre de membre de la communauté"
                  style={{color: mode.settings.textColor3, marginLeft: '3px'}}
                />
                <Typography
                  variant="subtitle5"
                  style={{color: mode.settings.textColor3}}>
                  {community.membersCount} membre{community.membersCount > 1 ? 's' : ''}
                </Typography>
              </div>
            </div>

            <div>
              {!member ? (
                <div></div>
              ) : isFavorite ? (
                <Button
                  className="remove-from-favorites"
                  startIcon={
                    <StarIcon
                      role="img"
                      aria-label={'Enlever la communauté des favoris'}
                      style={{color: 'white'}}
                    />
                  }
                  onClick={removeFromFavorite}>
                  <Typography variant={'subtitle9'}>
                    Enlever des favoris
                  </Typography>
                </Button>
              ) : (
                <Button
                  className="add-to-favorites"
                  startIcon={
                    <StarBorderIcon
                      role="img"
                      aria-label={'Mettre la communauté en favoris'}
                      style={{color: '#EFBA00'}}
                    />
                  }
                  onClick={addToFavorite}>
                  <Typography variant={'subtitle9'}>
                    Mettre en favoris
                  </Typography>
                </Button>
              )}
            </div>
          </div>

          <Box
            sx={{
              height: 200,
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              backgroundImage: `url(${axios.defaults.apiBaseURL}/${community.photo.uri})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          />

          <Typography
            sx={{marginTop: 1, height: 55}}
            variant="subtitle2"
            style={{color: mode.settings.textColor3}}>
            {community.name.text}
          </Typography>
          {member ? (
              <Button
                  className="btn-gradient"
                  variant="contained"
                  size="large"
                  startIcon={
                    <RemoveRedEyeIcon role="img" aria-label={'Voir la communauté'}/>
                  }
                  sx={{width: '100%', marginTop: 2}}
                  onClick={() => navigate(`/community/${community.id}`)}>
                <Typography variant={'subtitle3'}> Voir la communauté</Typography>
              </Button> ):
              <button
                  id={joinButtonDisabled ? 'btnGrey' : 'btnWhite'}
                  disabled={joinButtonDisabled}
                  onClick={() =>
                      join(community.id, community.public_access.bool)
                  }
                  style={{
                    cursor: 'pointer',
                  }}>
                {isLoadingJoin ? (
                    <CircularProgress color="inherit" size={25}/>
                ) : joinButtonDisabled ? (
                    textAfterJoin == 'Private' ? (
                        <Stack direction={'row'} spacing={1} alignItems={'center'} justifyContent={'center'}
                        >
                          <AccessTimeIcon
                              role="img"
                              aria-label={'Membre de la communauté'}
                              style={{color: mode.settings.textColor3}}
                          />
                          <Typography variant='subtitle6' style={{color: mode.settings.textColor3}}>
                            En attente de validation
                          </Typography>
                        </Stack>
                    ) : (
                        <Stack direction={'row'} spacing={1} alignItems={'center'}>
                          <CheckIcon
                              role="img"
                              aria-label={'Membre de la communauté'}
                              style={{color: mode.settings.textColor3}}
                          />
                          <Typography variant='subtitle6' style={{color: mode.settings.textColor3}}>
                            Vous êtes membre
                          </Typography>
                        </Stack>
                    )
                ) : (
                    <Stack direction={'row'} spacing={1} alignItems="center">
                      <LoginIcon
                          role="img"
                          aria-label={'Membre de la communauté'}
                          style={{color: mode.settings.color12}}
                      />
                      <Typography variant='subtitle6' style={{color: mode.settings.color12}}>
                        Rejoindre la communauté
                      </Typography>
                    </Stack>
                )}
              </button>
          }
          {community.actualites ? (
              community.actualities.length > 0 ? (
                  <div className="last-actualities">
                    <div className="bloc-title">
                      <Typography variant="h6" className="subtitle-regular">
                        Dernières actus
                      </Typography>
                    </div>

                    <Grid container spacing={1} sx={{padding: 2}}>
                      {community.actualities.map((actuality, i) => (
                          <Fragment key={i}>
                            <Grid item xs={9}>
                              <Typography
                                  className="body-medium"
                                  style={{color: mode.settings.textColor3}}>
                                {actuality.published_date}
                              </Typography>
                              <Typography style={{color: mode.settings.textColor3}}>
                                {actuality.title.text}
                              </Typography>
                            </Grid>
                            <Grid item xs={3}>
                              <Button
                                  variant="contained"
                                  className="btn-gradient"
                                  sx={{flexDirection: 'column'}}>
                                <Typography variant={'subtitle3'}>Voir</Typography>
                                <RemoveRedEyeIcon/>
                              </Button>
                            </Grid>
                            <hr className="separator"/>
                          </Fragment>
                      ))}
                    </Grid>
                  </div>
              ) : (
                  ''
              )
          ) : (
              ''
          )}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default CommunityCard;
